import React from 'react';
import { LABEL_LIMIT } from '../../constants';
import { normalizeWhitespace } from '../../utils/stringUtils';

export default function useUnique(
  labels: string[],
  value: string,
  dirty: boolean,
  apiDuplicated: boolean
) {
  const [errorMessage, setErrorMessage] = React.useState('');
  const newLabel = normalizeWhitespace(value);
  React.useEffect(() => {
    if (dirty) {
      if (newLabel.trim() === '') {
        setErrorMessage('Name cannot be blank');
      } else if (newLabel.length > LABEL_LIMIT) {
        setErrorMessage(`Name is too long, please use less than ${LABEL_LIMIT} chars`);
      } else if (
        labels.find((label) => label.toLowerCase() === newLabel.toLowerCase()) ||
        apiDuplicated
      ) {
        setErrorMessage('Name already exists');
      } else {
        setErrorMessage('');
      }
    }
  }, [newLabel, labels, dirty, apiDuplicated]);
  return errorMessage;
}
